export enum CustomizeThemeLocalizationEntityLevel {
  TENANT,
  LOCATION,
  KIOSK,
}
